import * as React from "react";
import * as ReactDOM from "react-dom";

import { Route, Router, Switch } from "react-router";
import Login from "./pages/login/Login";
import ClientLogin from "./pages/login/ClientLogin";
import UserLogin from "./pages/login/UserLogin";
import Home from "./pages/home/Home";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { history } from "./_helpers";

import "./index.css";
import { unregister } from "./registerServiceWorker";
import ClientSignup from "./pages/login/ClientSignup";
import ClientConfirm from "./pages/login/ClientConfirm";
declare global {
  interface Window {
    google: any;
    account: any;
    Chart: any;
  }
}
window.google = window.google || {};
window.account = window.account || {};

ReactDOM.render(
  <Router history={history}>
    <div id="app-root">
      <ToastContainer
        position={"bottom-center"}
        autoClose={5000}
        newestOnTop={true}
        closeOnClick
        rtl={false}
        pauseOnHover={true}
      />
      <Switch>
      <Route path={`/client/login`} component={ClientLogin} />
      <Route path={`/client/signup`} component={ClientSignup} />
      <Route path={`/client/confirm`} component={ClientConfirm} />
      <Route path={`/user/login`} component={UserLogin} />
        <Route path={`/login`} component={Login} />
        <Route path={`/`} component={Home} />
      </Switch>
    </div>
  </Router>,
  document.getElementById("root") as HTMLElement
);
unregister();



// WEBPACK FOOTER //
// ./src/index.tsx